import { createRouter, createWebHistory } from 'vue-router'

import IndexView from '../views/projects/ProjectIndexView.vue'
import NotFoundView from '../views/NotFoundView.vue'
import ProjectDetailView from '../views/projects/ProjectDetailView.vue'
import { authRoutes } from '@haskoning/vue-authentication-middleware'
import { storeToRefs } from 'pinia'
import ScenarioIndexView from '@/views/scenarios/ScenarioIndexView.vue'
import UserManagementView from '@/views/projects/UserManagementView.vue'
import { useProjectStore } from '@/stores/project'
import ScenarioDetailView from '@/views/scenarios/ScenarioDetailView.vue'
import ScenarioFormView from '@/views/scenarios/ScenarioFormView.vue'
import ScenarioResultView from '@/views/scenarios/ScenarioResultView.vue'
import HowToGetStartedView from '@/views/projects/HowToGetStartedView.vue'
import AboutSpinView from '@/views/projects/AboutSpinView.vue'
import ProjectExamplesView from '@/views/projects/ProjectExampleView.vue'
import ContactUsView from '@/views/projects/ContactUsView.vue'
import { useDjangoAuthStore } from '@/stores/authDjango'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/:pathMatch(.*)*',
      component: NotFoundView,
      name: 'not-found'
    },
    {
      path: '/',
      name: 'home',
      redirect: {
        name: 'auth-login'
      }
    },
    authRoutes,
    {
      path: '/project-index',
      name: 'project-index',
      component: IndexView,
      beforeEnter: (to, from) => {
        const store = useProjectStore()
        store.resetAll()
        return true
      }
    },
    {
      path: '/project/:id',
      name: 'project-detail',
      component: ProjectDetailView,
      redirect: {
        name: 'scenario-index'
      },
      children: [
        {
          path: '/project/:id',
          name: 'scenario-index',
          component: ScenarioIndexView
        },
        {
          path: '/project/:id/user-management',
          name: 'user-management',
          component: UserManagementView
        }
      ]
    },
    {
      path: '/project/:id/scenario/:scenarioId',
      name: 'scenario-detail',
      component: ScenarioDetailView,
      redirect: {
        name: 'scenario-result'
      },
      children: [
        {
          path: '/project/:id/scenario/:scenarioId/form',
          name: 'scenario-form',
          component: ScenarioFormView
        },
        {
          path: '/project/:id/scenario/:scenarioId/result',
          name: 'scenario-result',
          component: ScenarioResultView
        }
      ]
    },
    {
      path: '/how-to-get-started',
      name: 'how-to-get-started',
      component: HowToGetStartedView
    },
    {
      path: '/about-spin',
      name: 'about-spin',
      component: AboutSpinView
    },
    {
      path: '/project-examples',
      name: 'project-examples',
      component: ProjectExamplesView
    },
    {
      path: '/contact-us',
      name: 'contact-us',
      component: ContactUsView
    }
  ]
})

router.beforeEach(async (to) => {
  const authStore = useDjangoAuthStore()
  const { user } = storeToRefs(authStore)

  if (!user?.value?.id) {
    const userResponse = await authStore.reAuthenticate()
    if (userResponse) {
      authStore.$patch({
        user: userResponse.user
      })
    }
  }
  if (to.name && typeof to.name === 'string' && to.name.startsWith('auth-')) {
    if (user.value) {
      return { name: 'project-index' }
    }
    return true
  }
  // check auth and apply login redirect
  if (!user.value) {
    ;(authStore as any).loginRedirect = to // eslint-disable-line @typescript-eslint/no-explicit-any
    return { name: 'auth-login' }
  }
  return true
})

export default router
